export default __webpack_public_path__ + "static/media/raiffeisen_m3.8c182b38.png";